var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#E8F4F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.952 31.4509L48.2705 35.6283M23.952 31.4509L27.1639 17.5264L50.1059 18.9188L48.2705 35.6283M23.952 31.4509L14.3164 39.8057L37.2584 47.0001L48.2705 35.6283",
    stroke: "#014935",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2507 19.1323C22.0251 19.348 21.7404 19.4921 21.4327 19.5463C21.125 19.6006 20.8081 19.5626 20.5221 19.4371C20.2361 19.3116 19.9937 19.1042 19.8257 18.8413C19.6578 18.5783 19.5717 18.2716 19.5785 17.9598C19.5852 17.6481 19.6845 17.3453 19.8637 17.0899C20.0428 16.8344 20.2939 16.6377 20.5851 16.5246C20.8763 16.4116 21.1946 16.3873 21.4996 16.4547C21.8047 16.5221 22.0828 16.6784 22.299 16.9036C22.5877 17.206 22.7447 17.6103 22.7356 18.0279C22.7266 18.4455 22.5523 18.8426 22.2507 19.1323Z",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4617 45.933C46.236 46.1486 45.9513 46.2927 45.6436 46.347C45.336 46.4012 45.0191 46.3632 44.733 46.2377C44.447 46.1122 44.2046 45.9049 44.0367 45.6419C43.8687 45.379 43.7827 45.0722 43.7894 44.7605C43.7962 44.4487 43.8954 44.146 44.0746 43.8905C44.2538 43.6351 44.5048 43.4383 44.7961 43.3253C45.0872 43.2122 45.4055 43.1879 45.7106 43.2553C46.0156 43.3228 46.2938 43.479 46.5099 43.7043C46.7986 44.0067 46.9557 44.4109 46.9466 44.8286C46.9376 45.2462 46.7632 45.6433 46.4617 45.933Z",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8602 23.9392L48.4464 26.6727L54.1455 22.6198L52.6698 19.8961C52.6214 19.8077 52.5529 19.7323 52.4698 19.6762C52.3868 19.6202 52.2918 19.5852 52.1928 19.5741C52.0937 19.563 51.9935 19.5762 51.9005 19.6126C51.8075 19.6489 51.7244 19.7074 51.6582 19.783L43.9451 28.501C43.8601 28.5989 43.8069 28.7211 43.7928 28.8508C43.7787 28.9806 43.8044 29.1116 43.8663 29.226C43.9282 29.3404 44.0234 29.4326 44.1388 29.4901C44.2542 29.5475 44.3843 29.5674 44.5112 29.5471L55.8996 27.5963C55.9975 27.5801 56.0901 27.5403 56.1698 27.4803C56.2494 27.4203 56.3137 27.3418 56.3573 27.2513C56.401 27.1609 56.4226 27.0612 56.4205 26.9605C56.4184 26.8598 56.3925 26.7611 56.3451 26.6727L54.8602 23.9392Z",
    fill: "#F05A28",
    stroke: "#014935",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6973 29.9928L35.1556 28.3703C36.1239 26.9404 35.7498 25.0952 34.2807 24.0546C32.8116 23.0139 30.7013 23.0994 29.3451 24.2544C27.9888 25.4094 27.8056 27.2772 28.9165 28.6229C30.0274 29.9686 32.0893 30.3764 33.7389 29.5768L35.6973 29.9928",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9479 26.6647V26.6688",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6139 26.6647V26.6688",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2799 26.6647V26.6688",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5117 25.0882L39.9394 23.8073C39.1749 22.6785 39.4702 21.2218 40.6301 20.4002C41.7899 19.5786 43.4559 19.6461 44.5266 20.5579C45.5974 21.4698 45.742 22.9444 44.865 24.0067C43.9879 25.0691 42.3601 25.3911 41.0578 24.7598L39.5117 25.0882",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8451 37.7682C20.9167 38.3126 18.1234 39.0925 14.6032 39.5095C11.0831 39.9265 8.17954 39.8295 8.10795 39.2851C8.03636 38.7407 10.8297 37.9608 14.3503 37.5437C17.871 37.1265 20.7735 37.2238 20.8451 37.7682Z",
    stroke: "#F05A28",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2877 42.9606C18.9352 43.3605 16.4945 41.7073 13.8311 39.2519C11.1677 36.7965 9.29841 34.4861 9.65094 34.0862C10.0035 33.6863 12.4416 35.3426 15.1079 37.7942C17.7742 40.2458 19.6403 42.5607 19.2877 42.9606Z",
    stroke: "#F05A28",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.daa6c5f6f943a4fae164de0e43120024.svg";
export { ForwardRef as ReactComponent };